// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileAutoRefillToggle{display:flex;border-top:1px solid #fff;padding-top:15px;margin-top:15px;justify-content:space-between;align-items:center}.MobileAutoRefillToggle__label{display:flex;flex-direction:column;gap:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
